var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"register-pages",attrs:{"fill-height":"","fluid":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }